import api from '@/api/recalls';

export default {
    state: {
        recalls: [],
    },
    getters: {
        getSortableRecalls(state) {
            if (!state.recalls) return;
            return state.recalls.sort(function (a, b) {
                return new Date(a.recall_date) - new Date(b.recall_date);
            });
        }
    },
    mutations: {
        SET_RECALLS_DATA(state, payload) {
            state.recalls = payload;
        },
    },
    actions: {
        fetchRecalls({
            commit
        }) {
            api.get().then(({
                data: {
                    data: {
                        recalls
                    }
                },
                status
            }) => {
                if (status === 200) {
                    commit('SET_RECALLS_DATA', recalls);
                }
            });
        },
    },
};